import { Component, OnInit } from '@angular/core';
  import { Configuration } from '../../../app.constants';
import { Router } from '@angular/router';
@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.css']
})
export class FaqsComponent implements OnInit {


  constructor(public config:Configuration,public router:Router) { }


  ngOnInit() {
  }
  changeLink(frame){
    let url = frame.contentWindow.location.href;
    console.log(url)
    if(url.indexof('login')!=-1){
      this.router.navigate(['/login']);
    }
  }
}
